export default {
  login({ commit }, currentUser) {
    commit("login", currentUser);
  },
  logout({ commit }) {
    commit("logout");
  },
  toggleMenu({ commit }) {
    commit("toggleMenu");
  },
  addToCart({ commit }, item) {
    commit("addToCart", item);
  },
  removeFromCart({ commit }, index) {
    commit("removeFromCart", index);
  },
  clearCart({ commit }) {
    commit("clearCart");
  },
  updateBanner({ commit }, data) {
    commit("updateBanner", data);
  },
  setActiveOrder({ commit }, order) {
    commit("setActiveOrder", order);
  },
  startChatWith({ commit }, userId) {
    commit("startChatWith", userId);
  },
};
